
import { claimHasPolicy, claimHasWebUser, claimNotApproved, claimIncidentWithinCoverDates } from './claimRules.js'
import { MessageTypes } from '../../constants/messageConst.js'
import { ruleResult, ruleResultMessage } from './pipelineResult.js'

let canApproveClaimPipeline = {
    id: 1,
    name: 'canApproveClaimPipeline',
    rules: [
        claimNotApproved,
        claimHasPolicy,
        claimHasWebUser,
        (context) => {
            if (context) {
                let { objectInstance } = context
                if (objectInstance && objectInstance.excessCalculations != null && objectInstance.excessCalculations.length > 0) {
                    return ruleResult(3, 'claimHasExcess', true, null)
                }

                return ruleResult(3, 'claimHasExcess', false, ruleResultMessage(MessageTypes.MSG_ERROR, 'No excess calculation!'))
            }
        },
        claimIncidentWithinCoverDates
    ]
}

export { canApproveClaimPipeline }